module.exports = __webpack_public_path__ + "img/telegram-white.1dc75637.svg";